module.exports = __webpack_public_path__ + "static/media/infobip.665dada0.jpeg";